import React, {useMemo} from "react";
import {AsideMenuList} from "./AsideMenuList";
import {useHtmlClassService} from "../../../_core/MetronicLayout";
import { useSelector } from "react-redux";
import { AsideMenuListClient } from "./AsideMenuListClient";

export function AsideMenu({disableScroll}) {
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true)
    };
  }, [uiService]);
  const { user }          = useSelector((state) => state.auth);
  const role = user.data.roles[0].name;

  return (
    <>
      {/* begin::Menu Container */}
      <div
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
        {...layoutProps.asideMenuAttr}
      >
        {role =='client'?
          <AsideMenuListClient layoutProps={layoutProps} />
        :
          <AsideMenuList layoutProps={layoutProps} />
        }
      </div>
      {/* end::Menu Container */}
    </>
  );
}
